module.exports = __webpack_public_path__ + "img/jgdkj@2x.d094f3e2.png";